import stylesBreakpoint from 'common/styles/styles.breakpoint';
import { themedStyled } from 'common/styles/styletron.theme';

export const ItemContainer = themedStyled('div', {
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  gap: '8px',

  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});
